import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithInterceptor } from '../helpers';

// Define a service using a base URL and expected endpoints
export const api = createApi({
	reducerPath: 'api',
	baseQuery: baseQueryWithInterceptor,
	// Global tag types used for cache invalidation across slices
	tagTypes: [
		'KeyenceByProductionMethod',
		'BallooningSettings',
		'RobotProgramAudit',
		'Buildings',
		'BuildingIntegrationSettings',
		// Inventory management (racks/shelves/locations CRUD)
		'Racks',
		'Shelves',
		'Locations',
		'getMaterialOrders',
		'getMaterialRemnant',
		'InspectionPlan',
		'InspectionSample',
		'InspectionResults',
		'KeyenceValidationReport',
		'KeyenceProgram',
		'OrderLineItem',
		'Order',
		// Finishing / handling / cleaning catalog and its global batch minimum
		'ProcessSpecs',
		'ProcessMinBatch',
		'MaterialOrder',
		'Program',
		'ProgramScoringGrid',
		'ProgramScores',
		'ProgramMetrics',
		'CamOptimizations',
		'ProgramIssue',
		'ProgramReview',
		'ProgramFeedback',
		// Scheduling tags
		'Jobs',
		'Tasks',
		'StaffProfiles',
		'StaffMembers',
		'ShiftDayTemplates',
		'Machines',
		'MachineGroups',
		'Queues',
		'Exceptions',
		'ScheduleRuns',
		'Holidays',
		'BusinessHours',
		'FacilitySettings',
		'Roles',
		'PhantomTemplates',
		'AffinityConfig',
		'PrioritizationTables',
		'JobVarDefs',
		'Preflight',
		// Kit Tracking (tracked-card boards)
		'TrackedCard',
		'KitStagingAreas',
		'KitDekitAreas',
		// Kit Staging admin (areas/racks/dekit CRUD + dashboard)
		'KitMachineGroups',
		'KitRacks',
		'KitDashboard',
		// Traveler Audit (bulk PDF parsing runs)
		'TravelerAuditRun',
		'TravelerAuditPrintJob',
		'TravelerAuditRecovery',
		// Alro mill-certificate review queue
		'MaterialCertProposal',
		// Shop-floor "need more material" hot list and its audit trail
		'ShopFloorMaterialNeed',
		'ShopFloorReservationAudit',
		'ProductionQuestion',
	],
	endpoints: () => ({}),
});
